export const STUDIO_BASEPATH = `/studio`
